import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import './SearchModal.scss'
import RadioButton from '../../../../../components/RadioButton/RadioButton';
import Select, { components } from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { getLabTestList, getQueryReport, getSampleDataForCategory } from '../../../../../redux/actions/AnalyticalReportAction/QueryReportAction';
import { ReactComponent as AddIcon } from '../../../../../assets/images/CommonComponent/WhitePlus.svg'
import { parseJSON, validateDate } from '../../../../../utils/Helper';
import moment from 'moment';
import { TINYINT, DATETIME, DATE, STRING, INT, JSON_TYPE, ENUM, DROPDOWN, EMPTY, NOT_EMPTY, IS, IS_NOT, CONTAINS, START_WITH, NOT_CONTAINS, END_WITH, LESS_THAN, LESS_THAN_EQUAL, GREATER_THAN, GREATER_THAN_EQUAL } from '../../../../../Config/Constant';
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/CommonComponent/trash.svg"
import { ReactComponent as EditIcon } from "../../../../../assets/images/CommonComponent/pencil.svg"
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { ANALYTICAL_REPORT } from '../../../../../Router/RoutesURL';
import DatePicker from '../../../../../components/DatePicker/DatePicker';
import Button from '../../../../../components/Button/Button';
import CancelButton from '../../../../../components/Button/CancelButton';


const operatorList = [
  { label: "Is", value: IS, data_type: [TINYINT, DATETIME, DATE, STRING, INT, DROPDOWN, ENUM] },
  { label: "Is Not", value: IS_NOT, data_type: [TINYINT, DATETIME, DATE, STRING, INT, DROPDOWN, ENUM] },
  { label: "Contains", value: CONTAINS, data_type: [STRING] },
  { label: "Does Not Contain", value: NOT_CONTAINS, data_type: [STRING] },
  { label: "Starts With", value: START_WITH, data_type: [STRING] },
  { label: "Ends With", value: END_WITH, data_type: [STRING] },
  { label: "Less Than", value: LESS_THAN, data_type: [DATETIME, DATE, INT] },
  { label: "Less Than Equal To", value: LESS_THAN_EQUAL, data_type: [DATETIME, DATE, INT] },
  { label: "Greater Than", value: GREATER_THAN, data_type: [DATETIME, DATE, INT] },
  { label: "Greater Than Equal To", value: GREATER_THAN_EQUAL, data_type: [DATETIME, DATE, INT] },
  { label: "Empty", value: EMPTY, data_type: [TINYINT, DATETIME, DATE, STRING, INT, DROPDOWN, ENUM] },
  { label: "Not Empty", value: NOT_EMPTY, data_type: [TINYINT, DATETIME, DATE, STRING, INT, DROPDOWN, ENUM] },
]

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  height: '75%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  pb: 2
};

export default function SearchModal({ openModal, setOpenModal, onYes, text, hide }) {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()
  const data = useSelector(state => state?.queryReportReducer);
  const [filter, setFilter] = React.useState(localStorage.getItem('query') ? JSON.parse(localStorage.getItem('query')) : { condition: 'and', filter: [] })
  const [currentfilter, setCurrentFilter] = React.useState(null)
  const navigate = useNavigate()

  const handleClose = () => setOpenModal(false);

  const handleColumnChange = (e) => {
    let newData = {
      editIndex: currentfilter?.editIndex,
      label: e.label,
      column_name: e.column_name,
      data_type: e.data_type,
      table: e.table,
      table_name_alias: e.table_name_alias,
      json_key: e.json_key,
      for_unique_key_alias: e.for_unique_key_alias,
      row_id: e.row_id,
      extra_key: e.extra_key,
      enum_values: e.enum_values,
      selected_json_key: e.json_key,
      selected_json_key_label: e.sub_category_title,
      tableLabel: e.tableLabel,


      inputValue: e.data_type === TINYINT ? "1" : "",
      ...(e.data_type === TINYINT && { operatorLabel: 'Is', "operator": IS }),

    }
    setCurrentFilter(prev => (newData));
    if (e.data_type === DROPDOWN)
      dispatch(getSampleDataForCategory(newData))
  }

  const generateSubOptionslabel = (item, level = 1) => {
    let s = item?.[`nested_data_level${level}`]?.sub_category;
    if (!s)
      return ''
    return ` \n----> ${s} ${generateSubOptionslabel(item, level + 1)}`
  }

  const handleOperatorChange = (e) => {
    setCurrentFilter(prev => {
      return ({
        ...prev,
        "operatorLabel": e.label,
        "operator": e.value,
        ...(e.value === EMPTY && { "inputValue": '' }),
        ...(e.value === NOT_EMPTY && { "inputValue": '' })
      })
    });
  }

  const handleSearch = () => {
    let getData = parseJSON(localStorage.getItem('query')) || {}
    localStorage.setItem('query', JSON.stringify({ ...filter, columns: getData?.columns || [] }));
    searchParams.delete('page')
    navigate({
      pathname: `${ANALYTICAL_REPORT}`,
      search: `?${createSearchParams([...searchParams.entries()])}`,
    }, { replace: true })

    dispatch(getQueryReport({
      ...filter,
      columns: getData?.columns || [],
      page: searchParams.get("page") ? parseInt(searchParams.get("page")) + 1 : 1,
      pageLimit: searchParams.get("pageLimit") || 50,
      orderBy: searchParams.get("orderBy") || '',
      orderByType: searchParams.get("orderByType") || '',
    }))
    setOpenModal(false)
  }

  const handleDelete = (index) => {
    setFilter(prev => {
      let d = JSON.parse(JSON.stringify(prev))
      d.filter.splice(index, 1);
      return d;
    })
  }

  const handleAdd = () => {
    setFilter(prev => {
      let currentData = { ...currentfilter }
      let editIndex = currentData?.editIndex
      if (editIndex >= 0) {
        let temp = JSON.parse(JSON.stringify(prev));
        delete currentData.editIndex
        temp.filter[editIndex] = currentData;
        return temp;
      } else {
        return {
          ...prev,
          filter: prev.filter ? [
            ...prev.filter,
            currentData
          ] : [currentData]
        }
      }

    })
    setCurrentFilter(null);
  }

  const handleEdit = (index) => {
    setCurrentFilter(prev => {
      let newData = filter.filter[index]
      if (newData.for_unique_key_alias === "lab_t_s_f_") {
        dispatch(getLabTestList({ isStatic: 1, ...newData }))
      } else if (newData.data_type === DROPDOWN) {
      dispatch(getSampleDataForCategory(newData))
    }
      return {
        ...newData,
        editIndex: index
      }
    })
  }

  const handleResetColumn = () => {
    setCurrentFilter(null);
  }

  const handleReset = () => {
    // setCurrentFilter(null);
    setFilter({ condition: 'and', filter: [] })
  }

  const handleCancel = () => {
    setCurrentFilter(null);
  }

  const handleInputValueChange = (e) => {
    setCurrentFilter(prev => ({
      ...prev,
      "inputValue": e.target.value
    }))
  }

  const handleBooleanInput = (value) => {
    setCurrentFilter(prev => ({
      ...prev,
      "inputValue": value
    }))
  }


  const handleSelectInput = (value) => {
    setCurrentFilter(prev => ({
      ...prev,
      "inputValue": value.value
    }))
  }

  const handleDateInput = (value) => {
    if (!value) return;
    let date = moment(value).format('YYYY-MM-DD HH:mm:ss');
    setCurrentFilter(prev => ({
      ...prev,
      // "inputValue": prev.data_type===DATE ? date: (prev.inputValue ? `${date}${prev.inputValue.slice(10)}` : `${date} 00:00:00`)
      "inputValue": prev.data_type === DATE ? date.slice(0, 10) : date
    }))
  }

  // const handleTimeInput = (value)=>{
  //   let time=moment(new Date(value)).format('HH:mm:ss');
  //   setCurrentFilter(prev=>{
  //     let date = prev?.inputValue?.slice(0, 11)
  //     return({
  //       ...prev,
  //       "inputValue": prev.inputValue ? `${date} ${time}` : `${moment().format('YYYY-MM-DD')} ${time}`
  //     })
  //   })
  // }

  const CustomOption = (props) => {
    const ref = React.useRef();

    React.useEffect(() => {
      props.isSelected && ref.current.scrollIntoView();
    }, [props.isSelected]);

    return (
      <components.Option {...props} innerRef={ref} />
    );
  };

  return (
    <div>
      <Modal
        sx={{
          ".MuiBox-root": {
            border: "none", borderRadius: "10px", outline: "none"
          }
        }}
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="search-modal h-100 d-flex flex-column">
            <div className="">
              <div className="title">Advanced Search</div>
            </div>
            <div className="hr"></div>
            <div className="my-2 mb-4 flex-grow-1">
              <div className="d-flex h-100">
                <div className="filter-box pr-3">
                  <div>
                    <Select
                      className="advance-search-select"
                      classNamePrefix="select"
                      isSearchable={true}
                      name="color"
                      isLoading={data?.loadingKeys}
                      styles={{
                        container: (provided, state) => ({
                          ...provided,
                          width: "360px",

                        }),
                      }}
                      value={currentfilter?.label ? { label: currentfilter?.label, value: `${currentfilter?.tableLabel}-${currentfilter?.label}` } : null}
                      options={data?.keysCategoryList?.map(category => ({
                        label: category.category,
                        value: category.category,
                        options: category.sub_category.map(sub => ({
                          label: sub.sub_category_alias || sub.sub_category_title,
                          value: `${category.category}-${sub.sub_category_alias || sub.sub_category_title}`,
                          column_name: sub.column_name,
                          tableLabel: category.category,
                          table: sub.table,
                          table_name_alias: sub.table_name_alias,
                          data_type: sub.data_type,
                          json_key: sub.json_key,
                          for_unique_key_alias: sub.for_unique_key_alias,
                          row_id: sub.row_id,
                          extra_key: sub.extra_key,
                          enum_values: sub.enum_values,
                          sub_category_title: sub.sub_category_title,
                          id: sub.id
                        }))
                      }))}
                      components={{
                        Option: CustomOption
                      }}

                      placeholder='Select Column'
                      onChange={handleColumnChange}
                    />
                    {<>{generateSelectOptions({ json: currentfilter?.json_key, currentfilter, setCurrentFilter, dispatch })}</>}

                    {
                      currentfilter?.data_type !== TINYINT &&
                      <Select
                        className="advance-search-select mt-2"
                        classNamePrefix="select"
                        isSearchable={true}
                        name="color"
                        styles={{
                          container: (provided, state) => ({
                            ...provided,
                            width: "360px",

                          }),
                        }}
                        value={currentfilter?.operatorLabel ? operatorList.find(item => item.label === currentfilter?.operatorLabel) : null}
                        options={operatorList?.filter(item => item.data_type.includes(currentfilter?.data_type)) || []}
                        placeholder='Select Operator'
                        onChange={handleOperatorChange}
                        isDisabled={!currentfilter?.label}
                      />
                    }

                    {
                      currentfilter?.data_type === TINYINT &&
                      <div className='d-flex align-items-center justify-content-center mt-2'>
                        <RadioButton
                          name="boolean"
                          label="True"
                          value="1"
                          checked={currentfilter?.inputValue === '1'}
                          onChange={handleBooleanInput}
                        />
                        <RadioButton
                          name="boolean"
                          label="False"
                          value="0"
                          checked={currentfilter?.inputValue === '0'}
                          onChange={handleBooleanInput}
                        />
                      </div>
                    }
                    {
                      currentfilter?.data_type === ENUM && currentfilter?.operator !== EMPTY && currentfilter?.operator !== NOT_EMPTY &&
                      <Select
                        className="advance-search-select mt-2"
                        classNamePrefix="select"
                        isSearchable={true}
                        name="color"
                        styles={{
                          container: (provided, state) => ({
                            ...provided,
                            width: "360px",

                          }),
                        }}
                        value={currentfilter?.inputValue ? { label: currentfilter?.inputValue, value: currentfilter?.inputValue } : null}
                        options={currentfilter?.enum_values?.map((item => ({ label: item, value: item }))) || []}
                        placeholder='Select option'
                        onChange={handleSelectInput}
                      />
                    }

                    {
                      currentfilter?.data_type === DROPDOWN && currentfilter?.operator !== EMPTY && currentfilter?.operator !== NOT_EMPTY &&
                      <Select
                        className="advance-search-select mt-2"
                        classNamePrefix="select"
                        isSearchable={true}
                        name="color"
                        styles={{
                          container: (provided, state) => ({
                            ...provided,
                            width: "360px",

                          }),
                        }}
                        isLoading={data?.loadingSampleData}
                        value={currentfilter?.inputValue ? { label: currentfilter?.inputValue, value: currentfilter?.inputValue } : null}
                        options={!data?.loadingSampleData ? data.sampleData?.map((item => ({ label: item, value: item }))) : []}
                        placeholder='Select option'
                        onChange={handleSelectInput}
                      />
                    }

                    {[INT, STRING].includes(currentfilter?.data_type) && currentfilter?.operator !== EMPTY && currentfilter?.operator !== NOT_EMPTY && <input className="input-value mr-2" placeholder='Enter' type={(currentfilter?.data_type === STRING) ? 'text' : 'number'} value={currentfilter?.inputValue} onChange={handleInputValueChange} />}

                    {
                      [DATE, DATETIME].includes(currentfilter?.data_type) && currentfilter?.operator !== EMPTY && currentfilter?.operator !== NOT_EMPTY &&
                      <DatePicker
                        className='mt-2'
                        onChange={date => { handleDateInput(date) }}
                        showTime={currentfilter?.data_type === DATETIME}
                        value={validateDate(currentfilter?.inputValue) ? new Date((currentfilter?.inputValue || '').replace(' ', 'T')) : ''}
                        showMonthDropdown={true}
                        showYearDropdown={true}
                      />
                    }


                    {/* {
                    (currentfilter?.data_type===DATETIME) && 
                    <div className='mt-2'>
                      <TimeSelector 
                        ampm={true}
                        width={'100%'}
                        height={'30px'}
                        setTime={handleTimeInput}
                        time={currentfilter?.inputValue ? new Date(currentfilter.inputValue) : ''}
                      /> 
                    </div>
                  } */}
                    <div className='d-flex justify-content-center mt-3'>
                      <Button
                        text={currentfilter?.editIndex >= 0 ? 'Update' : 'Add'}
                        disabled={!(currentfilter?.label && currentfilter?.operator && (currentfilter?.operator !== EMPTY && currentfilter?.operator !== NOT_EMPTY ? currentfilter?.inputValue : true))}
                        className='py-1 px-3 rounded-lg'
                        icon={currentfilter?.editIndex >= 0 ? <EditIcon width={'12px'} /> : <AddIcon width={'9px'} />}
                        onClick={handleAdd}
                      />
                      <CancelButton
                        className='py-1 rounded-lg'
                        // icon={currentfilter?.editIndex>=0 ? '' : <ResetIcon strokeWidth={1}/>}
                        text={currentfilter?.editIndex >= 0 ? 'Cancel' : 'Reset'}
                        onClick={currentfilter?.editIndex >= 0 ? handleCancel : handleResetColumn}
                      />
                    </div>
                  </div>
                  <hr className='my-3' />
                  {/* {
                    ![ENUM, TINYINT].includes(currentfilter?.data_type) && currentfilter &&
                    <>
                      <div className='font-weight-bold text-center text-uppercase'>Sample Data </div>
                      <div className='sample-data my-2 border rounded p-2 flex-grow-1'>
                        {
                          data.loadingSampleData ?
                          <div className='text-center'><CircularProgress size={19} className='mt-1 mr-1' sx={{color: '#74613C'}} /></div>:
                          <div className='  overflow-scroll'>
                            {
                              currentfilter && data.sampleData?.length>0 ? 
                              <>
                                { data.sampleData?.filter(item=> item).slice(0, 4).map((item, index) => (
                                  <div className='item rounded p-2 mb-2' key={index}>
                                    {
                                      currentfilter.data_type===DATETIME && validateDate(item) ? moment(item, "YYYY-MM-DD hh:mm:ss").format("DD MMM, YYYY HH:mm A") :
                                      currentfilter.data_type===DATE && validateDate(item) ? moment(item).format('DD MMM, YYYY') :
                                      item || '-'
                                    }
                                  </div>
                                ))}
                              </>
                              :
                              <div className='text-muted text-center'>Select Column...</div>
                            }
                          </div>
                        }
                      </div>
                    </>
                  } */}
                </div>
                <div className="vhr"></div>
                <div className="query-box flex-grow-1 ml-2">
                  <div className="d-flex justify-content-between">
                    <div className='d-flex align-items-center'>
                      <span className='label mr-2'>Select Criteria: </span>
                      <RadioButton
                        name="logical-operator"
                        label="Any Criteria"
                        value="or"
                        checked={filter.condition === 'or'}
                        onChange={(value) => setFilter(prev => ({ ...prev, condition: value }))}
                      />
                      <RadioButton
                        name="logical-operator"
                        label="All Criteria"
                        value="and"
                        checked={filter.condition === 'and'}
                        onChange={(value) => setFilter(prev => ({ ...prev, condition: value }))}
                      />
                    </div>
                    <Button
                      // icon={<ResetIcon strokeWidth={1}  />}
                      className='py-1 rounded-lg'
                      text={'Reset'}
                      onClick={handleReset}
                    />
                  </div>
                  <div className="query w-100 mt-3">
                    {
                      filter.filter?.map((item, index) => {
                        let subLabels = generateSubOptionslabel(item, 1);
                        return (
                          <div className='bg-light d-flex align-items-center justify-content-between my-2 round p-2' key={index}>
                            <div className='d-flex mr-2'>
                              {index !== 0 ? <span className='bg-dark rounded p-1 py-0 align-self-start  text-uppercase text-white mr-2'>{filter.condition}</span> : ''}
                              <div>
                                <span className='font-weight-bold' style={{ color: '#5ebd78' }}>{item.label} <>{subLabels}</> {item.operatorLabel} </span>
                                {
                                  (item.operator === EMPTY || item.operator === NOT_EMPTY) ? '' :
                                    item.data_type === TINYINT ? (item?.inputValue === '1' ? 'True' : 'False') :
                                      item.data_type === DATE ? moment(item?.inputValue)?.format('DD MMM, YYYY') :
                                        item.data_type === DATETIME ? moment(item?.inputValue)?.format('DD MMM, YYYY hh:mm A') :
                                          item?.inputValue
                                }
                              </div>
                            </div>
                            <div className='flex-shrink-0'>
                              <span className='cursor-pointer mr-1' onClick={() => handleEdit(index)}><EditIcon fill={'#747474'} fontSize={'16px'} /></span>
                              <span className='cursor-pointer' onClick={() => handleDelete(index)}><DeleteIcon fill={'#747474'} width={'12px'} /></span>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center'>
              <Button
                className='py-1 rounded-lg'
                text={'SEARCH'}
                onClick={handleSearch}
              />
              <CancelButton
                className='py-1 rounded-lg'
                text={'CANCEL'}
                onClick={handleClose}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

const generateSelectOptions = ({ json, currentfilter, setCurrentFilter, level = 1, dispatch }) => {
  if (!json || typeof json === 'string')
    return;

  const handleSubCategoryChange = (e) => {
    let newData = {}
    setCurrentFilter(prev => {
      let updated = { ...prev };
      for (let i = level + 1; i <= 10; i++) {
        delete updated[`nested_data_level${i}`];
      }
      newData = {
        ...updated,
        data_type: e.data_type,

        [`nested_data_level${level}`]: {
          sub_category: e.label,
          data_type: e.data_type,
          json_key: e.json_key,
        },

        selected_json_key: Array.isArray(e.json_key) ? '' : e.json_key,
        selected_json_key_label: Array.isArray(e.json_key) ? '' : e.label,
        ...(e.data_type === ENUM && { enum_values: e.enum_values }),


        inputValue: e.data_type === TINYINT ? "1" : "",
        ...(e.data_type === TINYINT && { operatorLabel: 'Is', "operator": IS }),
        ...(e.id && { cat_id: e.id }),
      }
      return newData
    });
    if (currentfilter.for_unique_key_alias === "lab_t_s_f_") {
      dispatch(getLabTestList({ isStatic: 1, ...newData }))
    }else if (e.data_type === DROPDOWN) {
      dispatch(getSampleDataForCategory(newData))
    }
  }



  return (
    <>
      {
        Array.isArray(json) &&
        <Select
          className="advance-search-select mt-2"
          classNamePrefix="select"
          isSearchable={true}
          name="color"
          styles={{
            container: (provided, state) => ({
              ...provided,
              width: "360px",

            }),
          }}
          value={currentfilter[[`nested_data_level${level}`]]?.sub_category ? { label: currentfilter[[`nested_data_level${level}`]]?.sub_category, value: currentfilter[[`nested_data_level${level}`]]?.json_key } : null}
          options={json?.map((item) => ({
            label: item.sub_category,
            value: item.sub_category,
            json_key: item.json_key,
            data_type: item.data_type,
            enum_values: item.enum_values,
            id: item.id
          })) || []}
          placeholder='Select'
          onChange={handleSubCategoryChange}
        />
      }
      {generateSelectOptions({
        json: currentfilter[`nested_data_level${level}`]?.json_key,
        currentfilter,
        setCurrentFilter,
        level: level + 1,
        dispatch
      })}
    </>
  )
};